import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './clienteForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, getLista, getListaCidade, getListaBoletosPendentes } from './clienteActions';

const columns = [

];

class Cliente extends Component {

	state = {
		linhaSelecionada: null,
		modalImagem: null,
		imagemZoom: null,
		imagemZoomEscala: 1,
		sort: {
			field: 'razao_social',
			direction: 'asc' // 'asc' | 'desc'
		}
	}

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyDown);
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaCidade();
		this.props.getListaBoletosPendentes();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
			this.props.getListaBoletosPendentes();
		}, 30000);
    }

	componentWillUnmount() {		
		clearInterval(this.idIntervalAtualizacao);

		document.removeEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setModalImagem(null);
		}
	};

	componentDidUpdate(prevProps) {

		// VOLTOU PARA LISTA
		if (
			prevProps.modoTela !== 'lista'
			&& this.props.modoTela === 'lista'
		) {
			this.restaurarPosicaoScroll();
		}

		// ENTROU NO FORM
		if (
			prevProps.modoTela === 'lista'
			&& this.props.modoTela !== 'lista'
		) {
			window.scrollTo({
				top: 0,
				behavior: 'auto'
			});
		}
	}

	salvarPosicaoScroll = () => {
		this.setState({
			scrollLista: window.scrollY || window.pageYOffset
		});
	}

	restaurarPosicaoScroll = () => {
		setTimeout(() => {
			window.scrollTo({
				top: this.state.scrollLista || 0,
				behavior: 'auto'
			});
		}, 100);
	}

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}

					{this.props.modoTela == 'lista' &&
					<button
						onClick={() => {
							this.salvarPosicaoScroll();
														
							this.props.initForm({
								id_vendedor: this.props.sessao.id_vendedor || null
							});
							this.props.setModoTela('cadastro', {
								
							});
						}}
						style={{
							position: 'fixed',
							right: 20,
							bottom: 20,
							width: 56,
							height: 56,
							borderRadius: '50%',
							border: 'none',
							background: '#28a745',
							color: '#fff',
							fontSize: 24,
							fontWeight: 'bold',
							boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
							zIndex: 9999,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center'
						}}
					>
						<i
							className='fa fa-plus'
							style={{
								fontSize: 24
							}}
						/>
					</button>}
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.razao_social || 'Sem Razão Social'}
					${item.nome_fantasia || 'Sem Nome Fantasia'}
					${item.codigo}
					${item.cnpj || item.cpf || '-'}
					${item.id_vendedor}
					${item.endereco || 'Sem Endereço'}
					${item.numero ? `, ${item.numero}` : ''}
					${item.bairro ? `, ${item.bairro}` : ''}
					${item.cep ? `, ${item.cep}` : ''}
					${item.nome_cidade}
					${item.uf_cidade}
				`.toUpperCase().includes(pesquisar)
				);
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const lista = this.filtrar();

		return (
			<div style={{ paddingBottom: 50 }}>
				<Row>
					<InputPesquisa
						cols='12 12 12 12'
						label='Pesquisar'
						value={this.state.pesquisar}
						onChange={value => this.setState({
							...this.state,
							pesquisar: value
						})}
					/>
				</Row>

				<div>

					{lista.map((item, i) => {

						const boletoPendente = this.props.listaBoletosPendentes.filter(boleto => boleto.id_cliente == item.id_cliente 
							&& !boleto.vencido && !boleto.cartorio && !boleto.protesto).length > 0;
						const boletoVencido = this.props.listaBoletosPendentes.filter(boleto => boleto.id_cliente == item.id_cliente && boleto.vencido).length > 0;
						const boletoCartorio = this.props.listaBoletosPendentes.filter(boleto => boleto.id_cliente == item.id_cliente && boleto.cartorio).length > 0;
						const boletoProtesto = this.props.listaBoletosPendentes.filter(boleto => boleto.id_cliente == item.id_cliente && boleto.protesto).length > 0;

						return (
							<div
								key={item.id_cliente}
								style={{
									backgroundColor: '#fff',
									borderRadius: 16,
									marginBottom: 16,
									padding: 16,
									boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
									border: this.state.linhaSelecionada == item.id_cliente
										? '2px solid #5b7fff'
										: '1px solid #e5e5e5'
								}}
								onClick={e => {
									e.stopPropagation();
									//Retorna o cliente pra tela do pedido
									if (this.props.eventoPedido) {
										this.props.eventoPedido(item);
									} else {
										this.salvarPosicaoScroll();
										this.props.initForm({
											...item,
											tipo_documento: item.cnpj ? 'cnpj' : 'cpf',
											listaCobrancas: this.props.listaBoletosPendentes.filter(boleto => boleto.id_cliente == item.id_cliente)
										});
										this.props.setModoTela('cadastro', {
											...item
										});
									}
								}} >
								<div
									style={{
										fontSize: 14,
										fontWeight: 'bold',
										color: '#333'
									}}
								>
									{item.razao_social || 'Sem Razão Social'}
								</div>
								<div
									style={{
										fontSize: 12,
										color: '#333'
									}} >
									{item.nome_fantasia || 'Sem Nome Fantasia'}
								</div>
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between'
									}} >
									<div>
										<div style={{ fontSize: 10, color: '#999' }}>
											Código
										</div>

										<div style={{ fontWeight: 600, fontSize: 11 }}>
											{item.codigo}
										</div>
									</div>

									<div style={{ textAlign: 'right' }}>
										<div style={{ fontSize: 11, color: '#999' }}>
											CPF / CNPJ
										</div>

										<div style={{ fontWeight: 600, fontSize: 11 }}>
											{item.cnpj || item.cpf || '-'}
										</div>
									</div>
								</div>
								{!this.props.sessao.id_vendedor &&
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between'
									}} >
									<div>
										<div style={{ fontSize: 10, color: '#999' }}>
											ID Vendedor
										</div>

										<div style={{ fontWeight: 600, fontSize: 11 }}>
											{item.id_vendedor}
										</div>
									</div>
								</div>}
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between'
									}} >
									<div>
										<div style={{ fontSize: 10, color: '#999' }}>
											Endereço
										</div>

										<div style={{ fontWeight: 600, fontSize: 11 }}>
											{item.endereco || 'Sem Endereço'}
											{item.numero ? `, ${item.numero}` : ''}
											{item.bairro ? `, ${item.bairro}` : ''}
											{item.cep ? `, ${item.cep}` : ''}
										</div>
									</div>
								</div>
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
									}} >
									<div>
										<div style={{ fontSize: 10, color: '#999' }}>
											Cidade
										</div>

										<div style={{ fontWeight: 600, fontSize: 11 }}>
											{item.nome_cidade}
										</div>
									</div>

									<div style={{ textAlign: 'right' }}>
										<div style={{ fontSize: 10, color: '#999' }}>
											UF
										</div>

										<div style={{ fontWeight: 600, fontSize: 11 }}>
											{item.uf_cidade}
										</div>
									</div>
								</div>

								<div
									style={{
										display: 'flex',
										flexWrap: 'wrap',
										gap: 8,
										marginTop: 8
									}} >
									{boletoPendente &&
									<div
										style={{
											backgroundColor: '#fff3cd',
											color: '#856404',
											border: '1px solid #ffe69c',
											borderRadius: 20,
											padding: '6px 12px',
											fontSize: 10,
											fontWeight: 'bold',
											display: 'flex',
											alignItems: 'center',
											gap: 6
										}} >
										<i className='fas fa-file-invoice-dollar' />
										Cobrança em Aberto
									</div>}
									{boletoVencido &&
									<div
										style={{
											backgroundColor: '#ff2b2b',
											color: '#ffffff',
											border: '1px solid #ff2b2b',
											borderRadius: 20,
											padding: '6px 12px',
											fontSize: 10,
											fontWeight: 'bold',
											display: 'flex',
											alignItems: 'center',
											gap: 6
										}} >
										<i className='fas fa-calendar-times' />
										Cobrança Vencida
									</div>}
									
									{boletoCartorio &&
									<div
										style={{
											backgroundColor: '#ff2b2b',
											color: '#ffffff',
											border: '1px solid #ff2b2b',
											borderRadius: 20,
											padding: '6px 12px',
											fontSize: 10,
											fontWeight: 'bold',
											display: 'flex',
											alignItems: 'center',
											gap: 6
										}} >
										<i className='fas fa-envelope-open-text' />
										Cobrança em Cartório
									</div>}
									{boletoProtesto &&
									<div
										style={{
											backgroundColor: '#ff2b2b',
											color: '#ffffff',
											border: '1px solid #ff2b2b',
											borderRadius: 20,
											padding: '6px 12px',
											fontSize: 10,
											fontWeight: 'bold',
											display: 'flex',
											alignItems: 'center',
											gap: 6
										}} >
										<i className='fa fa-gavel' />
										Cobrança em Protesto
									</div>}

								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.cliente.modoTela,
	aguardando: state.cliente.aguardando,
	lista: state.cliente.lista,
	listaBoletosPendentes: state.cliente.listaBoletosPendentes
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaCidade, getListaBoletosPendentes
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Cliente);